import dayjs from "dayjs";

export function isMobile() {
    return navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
}

export function formatMoney(value: string): string {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'NGN',
    });
    return formatter.format(Number(value))
}

export function isEmail(val: string): boolean {
    return !val.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
}

const validationMessages: { [key: string]: any } = {
    isEmail: (props: any) => {
        const { field, value, title } = props || {}
        const isNotMail = isEmail(value || "");
        if (isNotMail) {
            return { status: false, message: `${title} field  must be an email` }
        }
        return { status: true }
    },
    minLength: (props: any) => {
        const { field, value = "", minLength, title } = props || {};
        if (value.length >= minLength) {
            return { status: true }
        }
        return { status: false, message: `${title} field  minimum length should be ${minLength} ` }
    },
    maxLength: (props: any) => {
        const { field, value = "", maxLength, title } = props || {};
        if (value.length > maxLength) {
            return { status: true }
        }
        return { status: false, message: `${title} field maximum length should be ${maxLength} ` }
    },
    required: (props: any) => {
        const { field, value, title } = props || {};
        if (!value) {
            return { status: false, message: `${title} field is required ` }
        }
        return { status: true }
    }
}
export function validate(formSettings: any, data: any) {
    for (let field in formSettings) {
        const settings = formSettings[field];
        const { title, ...rest } = settings;
        for (let checks in rest) {
            let fn = null
            if (typeof settings[checks] === "function") {
                fn = settings[checks];
            } else {
                fn = validationMessages[checks];
            }
            if (!fn) continue;
            const result = fn({ field, ...settings, value: data[field], data });              
            if (!result.status) {
                return result.message;
            }
        }
    }
}

export function getFullName(data: any) {
    if (data.firstName && data.lastName) {
        return `${data.firstName} ${data.lastName}`
    }
}

export function toSentenceCase(sentence:any) {
    if (Array.isArray(sentence)) {
        sentence = sentence.join(", ");
    }
    if (typeof sentence === 'string') {
        return sentence.split(" ").map(v => {
            const firstLetter = v.substring(0, 1).toUpperCase();
            const restLetter = v.substring(1).toLowerCase();
            return `${firstLetter}${restLetter}`;
        }).join(" ");
    } else {
        console.error("toSentenceCase: Input is not a string or array of strings", sentence);
        return ""; 
    }
}


export function convertTimeToFormat(date: any) {
    const now = dayjs();
    const nowTime = dayjs(date);
    const hours = now.diff(nowTime, "hour")
    if (hours <= 24) {
        return `${hours} hour(s)`
    }
    const days = now.diff(nowTime, "day")
    if (days <= 7) {
        return `${days} day(s)`
    }
    const week = now.diff(nowTime, "week");
    if (week <= 4) {
        return `${week} week(s)`
    }
    const month = now.diff(nowTime, "month");
    if (week <= 12) {
        return `${month} month(s)`
    }
    const year = now.diff(nowTime, "year");
    return `${year} year(s)`

}


export const profileCompletionWeights = {
  personalInformation: 10, // such as firstName and last Name
  biodata: 10, //gender and date of birth
  education: 10, //educational data
 otherSkills: 10 , //
  workExperience: 10, 
  documents:10, //resumeurl
  aboutme: 10,
  phone:10,
  passportUrl:10,
  address:10,
};

export function calculateProfileCompletionScore(userProfile: any) {
    //  console.log("UserProfile:", userProfile);
  let score = 0;
  let totalWeight = Object.values(profileCompletionWeights).reduce((acc, weight) => acc + weight, 0);

  for (const [section, weight] of Object.entries(profileCompletionWeights)) {
    switch (section) {
      case 'personalInformation':
        const hasPersonalInfo =  userProfile.firstName && userProfile.lastName 
        if (hasPersonalInfo) {
          score += weight;
        }
        break;
        case 'biodata':
        const bioInformation =  userProfile.gender && userProfile.dateOfBirth;
        if (bioInformation) {
          score += weight;
        }
        break;
        case 'phone':
      if (userProfile.phone && userProfile.phone.trim() !== '') {
        score += weight;
        
        }
        if (userProfile.passportUrl && userProfile.passportUrl.trim() !== '') {
    score += profileCompletionWeights.passportUrl;
  }

  if (userProfile.address && userProfile.address.trim() !== '') {
    score += profileCompletionWeights.address;
  }
     break;

      case 'otherSkills':
        if (userProfile[section] && userProfile[section].length > 0) {
          score += weight;
        }
        break;

      case 'workExperience':
       if (userProfile.workExperience && userProfile.workExperience.length > 0) {
      score += profileCompletionWeights.workExperience;
     }
       break;

      case 'education':
      if (userProfile.educationalInformation && userProfile.educationalInformation.length > 0) {
        score += profileCompletionWeights.education;
      }
      break;

      case
       'aboutme':
        if (userProfile.aboutme && userProfile.aboutme.formatted && userProfile.aboutme.formatted.trim() !== '') {
         score += weight;
          }
         break;

      case 'documents':
       
        if (userProfile.resumeUrl && userProfile.resumeUrl.trim() !== '') {
          score += weight;
        }
        break;

      default:
        if (userProfile[section] && userProfile[section].isComplete) {
          score += weight;
        }
        break;
    }
  }

const completionPercentage = (score / totalWeight) * 100;

return Math.min(parseFloat(completionPercentage.toFixed(2)), 100);
}

